import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { selectColor } from '@panel/commons';
import { getNeutralColors, getOrangeColors } from '@panel/commons/lib/theme';
import { Icon } from '@panel/commons/lib/Icon/Icon';
import { BodyText } from '@panel/commons/lib/typography';
import { useContactOwner } from '../../../../../hooks/useContactOwner';
import { useModal } from '../../../../../components/modal';

const FooterWrapper = styled.div`
  color: ${getNeutralColors('black')};
  padding: 0px 24px 0px 32px;
  font-family: 'Hind';
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
`;

const FooterContactOwnerWrapper = styled.div`
  display: flex;
  flex: row;
  height: 48px;
  align-items: center;
  padding: 11px 0px;
`;

const FooterContactOwnerText = styled(BodyText).attrs({
  size: 200
})`
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
`;

const FooterItemWrapper = styled.a`
  display: flex;
  flex: row;
  height: 48px;
  align-items: center;
  color: ${getNeutralColors('black')};
  text-decoration: none;
  padding: 11px 0px;
  :focus {
    color: ${getOrangeColors('base')};
    &::after {
      height: 40px;
      position: absolute;
      content: '';
    }
  }
  :hover {
    color: ${getOrangeColors('base')};
    cursor: pointer;
  }
  :active {
    font-weight: bold;
    color: ${selectColor('gray100')};
    &::after {
      height: 40px;
      position: absolute;
      content: '';
    }
  }
  :disabled {
    color: ${selectColor('gray25')};
    font-weight: 400;
  }
`;

const ItemName = styled.span`
  font-family: ${props => props.theme.fontFamily || 'Hind'};
`;

const LogOutText = styled.span`
  text-decoration: none;
`;

function HeaderMenuFooter(props) {
  const { t } = useTranslation();
  const siteId = process.env.REACT_APP_BUILD_SITE;
  const { onMenuItemClick } = props;
  const { letToggleModal } = useModal();
  const { getAgentData } = useContactOwner();

  const showAgent = () => {
    getAgentData();
    letToggleModal(true);
  };

  const { showOwner } = useContactOwner();
  return (
    <FooterWrapper data-panel='headerMenuFooter'>
      {showOwner && (
        <FooterContactOwnerWrapper onClick={() => showAgent()}>
          <Icon name='agent' size='100' margin='0 8px 0 0' />
          <FooterContactOwnerText>{t('panel.header.contactOwner.mobile.name')}</FooterContactOwnerText>
        </FooterContactOwnerWrapper>
      )}
      {siteId !== 'LLVE' && (
        <FooterItemWrapper
          href={t('panel.header.menufooter.helpUrl')}
          onClick={onMenuItemClick}
          target='_blank'
          rel='noopener noreferrer'
          data-panel='headerMenuFooter_help'
        >
          <ItemName>{t('panel.header.menufooter.help')}</ItemName>
        </FooterItemWrapper>
      )}
      <FooterItemWrapper href='/logout.bum' rel='noopener noreferrer' data-panel='headerMenuFooter_logout'>
        <LogOutText>{t('panel.header.menufooter.logout')}</LogOutText>
      </FooterItemWrapper>
    </FooterWrapper>
  );
}

export { HeaderMenuFooter };
